import { Stack } from '@/components/Molecules/Stack/Stack';
import { SectionTitle } from '@/components/Templates/SectionRows/SectionRowsTemplate';
import type { ComponentProps, ElementType } from 'react';
import type { FCC } from 'react-fc';

export interface ISecondaryPanelProps extends ComponentProps<typeof SectionTitle> {
    headingLevel?: ElementType;
}

/**
 * A standard panel for <aside> with a title and optional onward link
 */
export const SecondaryPanel: FCC<ISecondaryPanelProps> = ({
    title,
    headingLevel = 'h2',
    more,
    children,
    className,
    ...rest
}) => {
    return (
        <Stack className={className} {...rest}>
            <SectionTitle title={title} more={more} as={headingLevel} />
            {children}
        </Stack>
    );
};
